export interface IPNSPasswordResetInitiation {
  username: string;
  email: string;
}
